import { render } from "./title-bar.vue?vue&type=template&id=2694cf2b"
import script from "./title-bar.vue?vue&type=script&lang=js"
export * from "./title-bar.vue?vue&type=script&lang=js"

import "./title-bar.vue?vue&type=style&index=0&id=2694cf2b&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__